import history from '../../config/browserHistory';
import serverHistory from '../../config/serverHistory';
import { getVisibleLocales } from '@/tills/helpers/featureFlags';
import type { UserDetails } from './zodSchemas';

export const isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export function ssrSafeRedirect(url: string): void {
  if (isBrowser) {
    history?.push(url);
  } else {
    serverHistory?.push(url);
  }
}

const allLanguages = [
  { code: 'en', name: 'English (UK)', flag: '🇬🇧' },
  { code: 'us', name: 'English (US)', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'lb', name: 'Lëtzebuergesch', flag: '🇱🇺' },
  { code: 'be', name: 'Nederlands (België)', flag: '🇧🇪' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' }
];

export const languageConfig = allLanguages.filter((lang) => getVisibleLocales().includes(lang.code));

export function getUserInitials(user: UserDetails): string {
  const { first_name, last_name } = user || {};

  if (typeof first_name === 'string' && typeof last_name === 'string') {
    return `${first_name.charAt(0)}${last_name.charAt(0)}`.toUpperCase();
  }
  if (typeof first_name === 'string') {
    return `${first_name.charAt(0)}`.toUpperCase();
  }
  if (typeof last_name === 'string') {
    return `${last_name.charAt(0)}`.toUpperCase();
  }

  return '';
}

export const getHighestPermissionRole = (roles: string[] = []): string | null => {
  if (roles.includes('lush_pay_admin')) {
    return 'ADMIN';
  }
  if (roles.includes('lush_pay_support_admin')) {
    return 'SUPPORT_ADMIN';
  }
  return 'STORE_MANAGER';
};

export const downloadArrayBufferAsZip = (arrayBuffer: ArrayBuffer, filename: string): void => {
  const blob = new Blob([new Uint8Array(arrayBuffer)], { type: 'application/zip' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};

export const formatTimeForZone = (date: Date, timeZone: string): string =>
  date.toLocaleTimeString(undefined, {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

export const formatDateForZone = (date: Date, timeZone: string): string =>
  date.toLocaleDateString(undefined, {
    timeZone,
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
